/**
 * The upload engine the Deal Room uses: straight to storage, in resumable
 * chunks — the only way past Cloud Run's 32 MiB request limit. Anything the
 * direct path can't take still goes through the backend (`runDirectUploadJob`
 * falls back), so the upload manager does not know which ran.
 */
import { runDirectUploadJob } from "./directUploadEngine";
import { UploadJobRequest, UploadResponse } from "./uploadEngine";

export const runDealRoomUploadJob = (
	request: UploadJobRequest
): Promise<UploadResponse> => runDirectUploadJob(request);
